import type { ActivityRestoreButtonWrapperProps } from "./activity-restore-button.type";

import { getActivitySubjectModel, isBatchActivity } from "@/modules/activity";
import { isModelRestoreSupported } from "@/modules/model";

import { ActivityRestoreButton } from "./activity-restore-button.component";

export const ActivityRestoreButtonWrapper = ({
  activity,
}: ActivityRestoreButtonWrapperProps) => {
  const isDeleted = activity.subject?.deleted_at !== null;

  if (!isDeleted) return;

  const isBatch = isBatchActivity(activity);
  const subjectModel = getActivitySubjectModel(activity);

  const restoreModel = isBatch ? "activity" : subjectModel;
  const restoreId = isBatch ? activity.id : activity.subject?.id;

  if (!restoreModel || !isModelRestoreSupported(restoreModel)) return;

  return (
    <ActivityRestoreButton
      isBatch={isBatch}
      activity={activity}
      restoreModel={restoreModel}
      restoreId={restoreId}
    />
  );
};
